<div class="file-uploader-view">
  <!-- Unified Tool Header -->
  <div class="unified-tool-header">
    <div class="header-content">
      <div class="header-icon">
        <svg viewBox="0 0 24 24" class="tool-icon">
          <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
        </svg>
      </div>
      <div class="header-text">
        <h1>File Uploader</h1>
        <p>Upload and host your files with instant CDN links</p>
      </div>
    </div>
  </div>

  <!-- Tool Content -->
  <div class="tool-content">
    <!-- Upload Section -->
    <div class="upload-section">
      <div class="upload-container">
        <div class="upload-drop-zone" [class.has-files]="selectedFiles.length > 0" (click)="onDropZoneClick($event)"
          (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
          <input type="file" id="mainFileInput" #fileInput (change)="onFileSelected($event)" multiple accept="image/*, application/pdf" style="display: none" />

          <!-- Upload Icon & Text -->
          @if(selectedFiles.length === 0){
            <div class="upload-content">
              <div class="upload-icon d-flex justify-content-center">
                <svg viewBox="0 0 24 24" class="cloud-icon">
                  <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20M12,12L16,16H13.5V19H10.5V16H8L12,12Z" />
                </svg>
              </div>
              <div class="upload-text">
                <h3>Drop files here or click to browse</h3>
                <p>Support for JPEG, PNG, WebP formats and PDFs</p>
              </div>
              <div class="upload-button-alt" (click)="fileInput.click(); $event.stopPropagation()">
                <svg viewBox="0 0 24 24">
                  <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                </svg>
                Choose Files
              </div>
            </div>
          }

          <!-- Selected Files Preview -->
          @if(selectedFiles.length > 0){
            <div class="selected-files-preview">
              <div class="preview-header">
                <div class="preview-title">
                  <svg viewBox="0 0 24 24" class="files-icon">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                  </svg>
                  <div>
                    <h3>{{ selectedFiles.length }} file{{ selectedFiles.length === 1 ? '' : 's' }} selected</h3>
                    <p>Ready to upload</p>
                  </div>
                </div>
                <button class="clear-all-btn" (click)="clearAllFiles(); $event.stopPropagation()" title="Clear all files">
                  <svg viewBox="0 0 24 24">
                    <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                  </svg>
                </button>
              </div>

              <div class="preview-grid">
                @for(file of selectedFiles; track file; let i = $index){
                  <div class="file-preview-card">
                    <div class="file-preview-image">
                      <img
                        [src]="getFilePreview(file)"
                        [alt]="file.name"
                        (error)="$event.target.style.display = 'none'"
                        (load)="$event.target.style.display = 'block'"
                        style="display: none"
                      />
                      <div class="file-overlay">
                        <button class="remove-file-btn" (click)="removeFile(i, $event)" title="Remove file">
                          <svg viewBox="0 0 24 24">
                            <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div class="file-info">
                      <div class="file-name" [title]="file.name">{{ file.name }}</div>
                      <div class="file-size">{{ file.size | number }} bytes</div>
                    </div>
                  </div>
              }

                <!-- Add More Button -->
                <div class="add-more-card" (click)="addMoreFiles($event)">
                  <div class="add-more-content">
                    <svg viewBox="0 0 24 24" class="add-icon">
                      <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
                    </svg>
                    <span>Add More</span>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>

        <!-- Upload Actions -->
        @if(selectedFiles.length > 0){
          <div class="upload-actions">
            <button class="upload-button" [disabled]="selectedFiles.length === 0 || isUploading" (click)="uploadFiles()" [class.loading]="isUploading">
              <span class="button-content">
                @if(!isUploading){
                  <svg viewBox="0 0 24 24" class="button-icon">
                    <path d="M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z" />
                  </svg>
                }@else{
                  <div class="loading-spinner"></div>
                }
                <span>{{ isUploading ? 'Uploading...' : 'Upload ' + selectedFiles.length + ' file' + (selectedFiles.length === 1 ? '' : 's') }}</span>
              </span>
            </button>
          </div>
        }
      </div>
    </div>

    <!-- Error State -->
    @if(uploadError){
      <div class="error-section">
        <div class="error-card">
          <svg viewBox="0 0 24 24" class="error-icon">
            <path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
          </svg>
          <div class="error-content">
            <h3>Upload failed</h3>
            <p>{{ uploadError }}</p>
          </div>
        </div>
      </div>
    }

    <!-- Success Message -->
    @if(uploadSuccess && uploadedFiles.length > 0){
      <div class="success-section">
        <div class="success-card">
          <svg viewBox="0 0 24 24" class="success-icon">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
          <div class="success-content">
            <h3>Upload successful!</h3>
            <p>{{ uploadedFiles.length }} file{{ uploadedFiles.length === 1 ? '' : 's' }} uploaded successfully</p>
          </div>
        </div>
      </div>
    }

    <!-- Uploaded Files Section -->
    @if(uploadedFiles.length > 0){
      <div class="uploaded-section">
        <div class="uploaded-header">
          <div class="uploaded-title">
            <svg viewBox="0 0 24 24" class="uploaded-icon">
              <path
                d="M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M7,6H17V8H7V6M7,9H17V11H7V9M7,12H14V14H7V12Z"
              />
            </svg>
            <div>
              <h2>Uploaded Files</h2>
              <span class="uploaded-count">{{ uploadedFiles.length }} image{{ uploadedFiles.length === 1 ? '' : 's' }} ready to use</span>
            </div>
          </div>
        </div>

        <div class="uploaded-grid">
          @for(file of uploadedFiles; track file; let i = $index){
            <div class="uploaded-card" [class.copied]="file.isCopied">
              <div class="uploaded-image">
                @if(file.extension !== 'pdf'){
                  <img [src]="file.url" [alt]="file.name" />
                }@else if(file.extension === 'pdf'){
                  <img src="https://dev-storage-v4.s3.eu-west-3.amazonaws.com/shared/b5a0754b-22fd-45c3-a81d-b43eb6a64b16.png" alt="PDF icon" />
                }
                <div class="image-overlay">
                  <a [href]="file.url" target="_blank" class="view-btn" title="View full size">
                    <svg viewBox="0 0 24 24">
                      <path
                        d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"
                      />
                    </svg>
                  </a>
                </div>
              </div>

              <div class="uploaded-content">
                <div class="uploaded-info">
                  <div class="image-name" [title]="file.name">{{ file.name }}</div>
                  <div class="image-url" [title]="file.url">{{ file.url }}</div>
                </div>

                <div class="uploaded-actions-card">
                  <button class="copy-btn" (click)="copyFileUrl(file.url, i)" [disabled]="file.isCopied" [title]="file.isCopied ? 'Copied to clipboard!' : 'Copy URL to clipboard'">
                    @if(!file.isCopied){
                      <svg viewBox="0 0 24 24">
                        <path d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" />
                      </svg>
                    }@else{
                      <svg viewBox="0 0 24 24">
                        <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                      </svg>
                    }
                    <span>{{ file.isCopied ? 'Copied!' : 'Copy URL' }}</span>
                  </button>
                </div>
              </div>
            </div>
        }
        </div>
      </div>
    }
  </div>
  <!-- Close tool-content -->
</div>
